let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ijPJo")).then(() => parcelRequire('g7f9W'));